import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconEndAdornment } from 'components/Button';
import { UnorderedList } from 'components/Lists';
import { Heading } from 'components/Typography';
import { VideoPlayer } from 'components/VideoPlayer';
import { MarkdownText } from 'domains/contentful/MarkdownText';
import { LearningPathCtx, withLearningPathContext } from 'domains/learning-path/context';
import { LearningPathStepID } from 'domains/learning-path/steps';

const StrategyOverviewContent: React.FC = () => {
  const { learningPath, onNavigateToStep } = useContext(LearningPathCtx);
  const { t } = useTranslation();

  const {
    strategyOverviewSection: {
      fields: { termsToKnow, overview, videoLink },
    },
  } = learningPath;

  const handleClick = () => onNavigateToStep(LearningPathStepID.howToUseIt, true);

  return (
    <>
      <Heading level="h3" useDefaultMargins>
        {t('learningPath.strategyOverview')}
      </Heading>

      <MarkdownText useDefaultMargins>{overview}</MarkdownText>

      {termsToKnow && (
        <div className="mb-40">
          <Heading level="h4" useDefaultMargins>
            {t('learningPath.strategyOverview.termsToKnow')}
          </Heading>

          <UnorderedList>
            {termsToKnow.map(({ fields: { term, definition } }) => (
              <UnorderedList.Item key={term}>
                <Heading level="h5" className="mb-8 font-semibold">
                  {term}
                </Heading>
                <span>{definition}</span>
              </UnorderedList.Item>
            ))}
          </UnorderedList>
        </div>
      )}

      {videoLink && <VideoPlayer videoLink={videoLink} />}

      <Button
        size="lg"
        onClick={handleClick}
        endAdornment={<IconEndAdornment name="AngleRight" />}
        className="sm-d:w-full"
      >
        {t('learningPath.continueButton')}
      </Button>
    </>
  );
};

export default withLearningPathContext(StrategyOverviewContent, LearningPathStepID.strategyOverview);
